export { Root as Tooltip, Trigger as TooltipTrigger } from "@rn-primitives/tooltip";
export type { TriggerRef as TooltipTriggerRef } from "@rn-primitives/tooltip";
